module.exports = __webpack_public_path__ + "img/lmgl.cde20709.jpg";